import React from 'react';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from '@material-ui/icons';
import useCountrySelectState from './useCountrySelectState';
import { useStyles } from '../checkoutDrawer.styles';

function CountrySelect ({ value, onChange, onBlur, error }) {
    const classes = useStyles();
    const {
        open,
        setOpen,
        query,
        setQuery,
        activeIndex,
        setActiveIndex,
        containerRef,
        searchRef,
        listRef,
        openUpward,
        selected,
        filtered,
        select,
        handleKeyDown,
    } = useCountrySelectState({ value, onChange });

    const listboxId = 'co-country-listbox';

    return (
        <div className={classes.countrySelect} ref={containerRef}>
            <button
                type="button"
                className={`${classes.countryTrigger} ${error ? classes.inputError : ''} ${open ? classes.countryTriggerOpen : ''}`}
                onClick={() => setOpen((o) => !o)}
                onBlur={onBlur}
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label="Country"
            >
                <span className={selected ? classes.countryValue : classes.countryPlaceholder}>
                    {selected ? selected.name : 'Select a country'}
                </span>
            </button>

            {open && (
                <div className={`${classes.countryPanel} ${openUpward ? '' : classes.countryPanelBelow}`} role="dialog" aria-label="Select a country">
                    <div className={classes.countrySearchRow}>
                        <SearchIcon className={classes.countrySearchIcon} fontSize="small" aria-hidden="true" />
                        <input
                            ref={searchRef}
                            className={classes.countrySearchInput}
                            type="text"
                            placeholder="Search countries"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            aria-label="Search countries"
                            aria-controls={listboxId}
                            autoComplete="off"
                        />
                    </div>

                    <ul className={classes.countryList} ref={listRef} role="listbox" id={listboxId} aria-label="Countries">
                        {filtered.length === 0 ? (
                            <li className={classes.countryEmpty}>No matches</li>
                        ) : (
                            filtered.map((c, i) => {
                                const isActive = i === activeIndex;
                                const isSelected = c.iso2 === value;
                                return (
                                    <li
                                        key={c.iso2}
                                        data-index={i}
                                        role="option"
                                        aria-selected={isSelected}
                                        className={`${classes.countryOption} ${isActive ? classes.countryOptionActive : ''} ${isSelected ? classes.countryOptionSelected : ''}`}
                                        onMouseEnter={() => setActiveIndex(i)}
                                        onClick={() => select(c)}
                                    >
                                        <span>{c.name}</span>
                                        {isSelected && <span className={classes.countryCheck} aria-hidden="true">✓</span>}
                                    </li>
                                );
                            })
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
}

CountrySelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    error: PropTypes.bool,
};

export default CountrySelect;
